import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "credit-record"
};
const _hoisted_2 = {
  class: "toolbox"
};
const _hoisted_3 = {
  class: "wrapper"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "客户名称", -1);

const _hoisted_5 = {
  class: "wrapper"
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "回款方式", -1);

const _hoisted_7 = {
  class: "wrapper"
};

const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "回款时间", -1);

const _hoisted_9 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_11 = /*#__PURE__*/_createTextVNode("支付信息");

const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "流水号：", -1);

const _hoisted_13 = {
  style: {
    "margin": "10px 0"
  }
};

const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "收款账号：", -1);

const _hoisted_15 = {
  style: {
    "margin": "10px 0"
  }
};

const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "支付时间：", -1);

const _hoisted_17 = /*#__PURE__*/_createTextVNode("关闭");

import { ref, onMounted, reactive } from 'vue';
import Axios from '@/request/createAxiosInstalce';
import { getVexTableProps } from '@/config';
import { ElMessageBox, ElMessage } from 'element-plus';
import { getSalemanSupplier } from '@/request';
export default {
  name: 'index',

  setup(__props) {
    const search = ref({
      repaymentMethod: '',
      custName: ''
    });
    const dateRange = ref([]);
    const table = ref();
    const tableOptions = getVexTableProps({
      columns: [{
        title: '客户名称',
        field: 'custName',
        width: 100
      }, {
        title: '回款金额',
        field: 'repaymentAmount'
      }, {
        title: '涉及订单',
        field: 'orderCount',
        slots: {
          default: 'orderCount'
        }
      }, {
        title: '回款时间',
        field: 'repaymentTime'
      }, {
        title: '客户回款方式',
        field: 'repaymentMethod',
        slots: {
          default: 'repaymentMethod'
        }
      }, {
        title: '回款人/提交人',
        field: 'repaymentLinkMan'
      }, {
        title: '回款团队',
        field: 'supplierName'
      }, {
        title: '操作',
        slots: {
          default: 'operation'
        },
        width: 110
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(resolve => {
            let params = _objectSpread({
              page: page.currentPage,
              pageSize: page.pageSize
            }, search.value);

            if (dateRange.value && dateRange.value.length) {
              params.startDate = dateRange.value[0];
              params.endDate = dateRange.value[1];
            }

            Axios.get('/admin/creditManage/rePayment/record', {
              params
            }).then(res => {
              if (!res.data.success) return;
              resolve({
                total: res.data.data.total,
                result: res.data.data.list
              });
            });
          })
        }
      }
    });

    function reset() {
      search.value = {
        repaymentMethod: '',
        custName: ''
      };
      dateRange.value = [];
      table.value.commitProxy('reload');
    }

    const dialog = reactive({
      show: false,
      data: {}
    });

    function checkDetail(row) {
      dialog.show = true;
      dialog.data = row;
    }

    function submit() {}

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_input, {
        modelValue: search.value.custName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => search.value.custName = $event),
        placeholder: "请输入客户名称"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_el_select, {
        modelValue: search.value.repaymentMethod,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => search.value.repaymentMethod = $event),
        placeholder: "请选择回款方式",
        style: {
          "width": "220px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "全部",
          value: ""
        }), _createVNode(_component_el_option, {
          label: "线下打款",
          value: "1"
        }), _createVNode(_component_el_option, {
          label: "线上支付",
          value: "2"
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_el_date_picker, {
        modelValue: dateRange.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dateRange.value = $event),
        type: "daterange",
        "value-format": "YYYY-MM-DD",
        "start-placeholder": "开始时间",
        "end-placeholder": "结束时间",
        "unlink-panels": ""
      }, null, 8, ["modelValue"])]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[3] || (_cache[3] = $event => table.value.commitProxy('reload'))
      }, {
        default: _withCtx(() => [_hoisted_9]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: reset
      }, {
        default: _withCtx(() => [_hoisted_10]),
        _: 1
      })]), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        orderCount: _withCtx(({
          row
        }) => [_createElementVNode("span", null, _toDisplayString(row.orderCount), 1)]),
        repaymentMethod: _withCtx(({
          row
        }) => [_createElementVNode("span", null, _toDisplayString(row.repaymentMethod == 1 ? '线下结算' : '在线支付'), 1)]),
        operation: _withCtx(({
          row
        }) => [_createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: $event => checkDetail(row)
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 16), _createVNode(_component_el_dialog, {
        modelValue: dialog.show,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => dialog.show = $event),
        title: "支付信息"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[4] || (_cache[4] = $event => dialog.show = false)
        }, {
          default: _withCtx(() => [_hoisted_17]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", null, [_hoisted_12, _createElementVNode("span", null, _toDisplayString(dialog.data.repaymentTxSn), 1)]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("span", null, _toDisplayString(dialog.data.repaymentPayAccount), 1)]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("span", null, _toDisplayString(dialog.data.repaymentTime), 1)])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};